<div class="menu-burguer" (click)="openMenu()">
    <div class="menu-burguer__icon" [ngClass]="isOpen ? 'menu-burguer__icon--open' : ''"></div>
    <div class="menu-burguer__text">MENU</div>
</div>

<nav *ngIf="isOpen" class="nav">
    <ul class="nav__list">
        <li class="nav__list_item">HOME</li>
        <li class="nav__list_item">CONTATO</li>
    </ul>
</nav>
